import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { CadRecordDataPoint } from '../store/cadImport.types'
import { CadImportConstants } from '../store/cadImport.constants'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { ITimesState } from '../../times/store/times.types'
import { IDispositionState } from '../../destinationAddress/store/destinationAddress.types'
import { getTimesSelector } from '../../times/selectors'
import { getDestinationAddressSelector } from '../../destinationAddress/selectors/destinationAddress.selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { onSelectPCR } from '../../home/store/home.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { buildPcrSummary } from '../../../utilities/pcr.util'
import { setCadComments } from '../../sceneDescription/store/sceneDescription.actions'

export function* wipeCadData() {
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  const times: ITimesState = yield select(getTimesSelector)
  const disposition: IDispositionState = yield select(getDestinationAddressSelector)

  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocUpdated: any = { ...pcrDoc, times, disposition }
    const importedCadData = pcrDoc.cadImport?.importedCadData
    importedCadData?.map((dataPoint: CadRecordDataPoint) => {
      const keys = dataPoint.appStateLocation.split('.')
      if (keys.length === 1) {
        return (pcrDocUpdated[keys[0]] = '')
      } else if (keys.length === 2) {
        return (pcrDocUpdated[keys[0]][keys[1]] = '')
      } else if (keys.length === 3) {
        return (pcrDocUpdated[keys[0]][keys[1]][keys[2]] = '')
      }
    })

    if (importedCadData?.find((i) => i.id === 'COMMENTS')) {
      yield put(setCadComments(''))
    }

    if (importedCadData?.find((i) => i.id === 'PT_DOB') || importedCadData?.find((i) => i.id === 'PT_AGE')) {
      pcrDocUpdated.patient.patientDemographics.dOB = null
      pcrDocUpdated.patient.patientDemographics.age = null
      pcrDocUpdated.patient.patientDemographics.ageUnit = null
    }

    try {
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      yield put(onSelectPCR(buildPcrSummary(pcrDocUpdated)))
    } catch (e) {
      yield put(throwPcrException(`wipeCadData() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* wipeCadDataSaga() {
  yield takeLatest([CadImportConstants.WIPE_CAD_DATA], performWithMutexHOG, wipeCadData)
}
